import c from "classnames";
import { useNavigate, useViewTransitionState } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";

import { useMainLayoutProvider } from "@providers/MainLayoutProvider/useMainLayoutProvider";

import { CurrentClientSelect } from "@components/CurrentClientSelect/CurrentClientSelect";

import { Box } from "@design-system/Box/Box";
import { Clickable } from "@design-system/Clickable/Clickable";
import { Icon } from "@design-system/Icon/Icon";
import { NavigationItem } from "@design-system/NavigationItem/NavigationItem";
import { Text } from "@design-system/Text/Text";

import { routes } from "@pages/routes";

import classes from "./ClientMenu.module.css";

export const ClientMenu = () => {
  const navigate = useNavigate();
  const { closeMobileNavigation } = useMainLayoutProvider();
  const { clientId } = useTypedParams(routes.portal.clients.client);
  const isTransitioning = useViewTransitionState(routes.portal.clients.$path());

  const handleBackClick = () => {
    navigate(routes.portal.dashboard.$path(), {
      viewTransition: true,
    });
  };

  return (
    <nav className={c(classes.nav, !isTransitioning && classes.static)}>
      <div className={classes.backButtonWrapper}>
        <Box padding="12px 16px 12px 16px">
          <div className={classes.backButton}>
            <Clickable outline="sm" onClick={handleBackClick}>
              <Box gap={4} align="center" padding="0px 8px">
                <Icon size="xs" icon="faChevronLeft" />
                <Text
                  color="textSecondary"
                  size={12}
                  weight={600}
                  uppercase
                >
                  Organization
                </Text>
              </Box>
            </Clickable>
          </div>
        </Box>
      </div>

      <Box direction="column" gap={2} align="start" padding="4px 8px">
        <Box
          padding="0 0 12px 0"
          direction="row"
          gap={16}
          stretch
          grow={1}
        >
          <CurrentClientSelect onChange={closeMobileNavigation} />
        </Box>

        <NavigationItem
          name="Dashboard"
          to={routes.portal.clients.client.dashboard.$buildPath({
            params: {
              clientId,
            },
          })}
          icon="faGrip"
          onClick={closeMobileNavigation}
        />
        <NavigationItem
          name="Applications"
          icon="faShapes"
          to={routes.portal.clients.client.applications.$buildPath({
            params: {
              clientId,
            },
          })}
          onClick={closeMobileNavigation}
        />
        <NavigationItem
          name="Notifications"
          icon="faBell"
          to={routes.portal.clients.client.notifications.$buildPath({
            params: {
              clientId,
            },
          })}
          onClick={closeMobileNavigation}
        />
        <NavigationItem
          name="Users"
          icon="faUser"
          to={routes.portal.clients.client.clientEmployees.$buildPath({
            params: {
              clientId,
            },
          })}
          onClick={closeMobileNavigation}
        />
        <NavigationItem
          name="Record"
          to={routes.portal.clients.client.record.$buildPath({
            params: {
              clientId,
            },
          })}
          icon="faFileInvoice"
          onClick={closeMobileNavigation}
        />
        <NavigationItem
          name="Extension"
          to={routes.portal.clients.client.extension.$buildPath({
            params: {
              clientId,
            },
          })}
          icon="faPlug"
          onClick={closeMobileNavigation}
        />
      </Box>
    </nav>
  );
};
